module.exports = __webpack_public_path__ + "static/media/2-1.16d59b43.webp";